import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ShareddtaService } from '@app/services/shareddta.service';
import { AfterViewInit } from '@angular/core';
import { BreadcrumbService } from '@app/services/breadcrumb.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements AfterViewInit {
  isLoggedIn: any = false;
  isRoleIn: any = false;

  ngOnInit(): void {
    this.breadcrumbService.clear();
  }

  constructor(public authService: AuthServiceService, public router: Router, private shareddta: ShareddtaService, private breadcrumbService: BreadcrumbService) {
    this.authService.getDashboard().subscribe((data: any) => {
      this.isLoggedIn = data;
    });
    this.authService.getRole().subscribe((data: any) => {
      if (data) {
        this.isRoleIn = data[0];
      }
    });
  }

  ngAfterViewInit(): void {
    this.shareddta.signalPageReady();
  }
}
